// External
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// Internal
import { fontFamily } from "../../../theme";
import { getLinkClassName } from "../../styles/global-styles";

const Link = styled.a.attrs((props) => ({
  className: getLinkClassName(props.tone),
}))`
  cursor: pointer;
  font-size: ${(props) => props.$fontSize || "16px"};
  font-family: ${(props) => props.$fontFamily || fontFamily.regular};
  font-weight: ${(props) => props.$fontWeight || "normal"};

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.$inline &&
    css`
      display: inline-flex;
      align-items: center;
      gap: 8px;
    `}
`;

Link.defaultProps = {
  tone: "default",
};

Link.propTypes = {
  color: PropTypes.string,
  tone: PropTypes.oneOf(["default", "muted"]),
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default Link;
